import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ModalProvider } from './context/ModalContext';
import Home from './pages/Home';
import About from './pages/About';
import WavelengthNew from './pages/WavelengthNew';
import WavelengthSession from './pages/WavelengthSession';
import AdminPanel from './pages/AdminPanel';
import Profile from './pages/Profile';
import Directory from './pages/Directory';
import TeamAdmin from './pages/TeamAdmin';
import AcceptInvite from './pages/AcceptInvite';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <ModalProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/wavelength/new" element={<WavelengthNew />} />
            <Route path="/wavelength/:slug" element={<WavelengthSession />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/profile/:userId" element={<Profile />} />
            <Route path="/directory" element={<Directory />} />
            <Route path="/team" element={<TeamAdmin />} />
            <Route path="/invite/:token" element={<AcceptInvite />} />
          </Routes>
        </BrowserRouter>
      </ModalProvider>
    </AuthProvider>
  );
}

export default App;
